module.exports = __webpack_public_path__ + "img/Telegram.e4cc10b2.svg";